module.exports = __webpack_public_path__ + "static/media/veikals_paka_4.d8f34680.png";